/**
 * user-activity.api.ts — Reporte de actividad de usuarios (última actividad
 * combinada de login del dashboard + operaciones de campo vía Telegram).
 * Espejo de `handleGetUserActivityReport` en aws-serverless/src/api/reports.handler.ts.
 */

import { apiClient } from './client';

export interface UserActivityRow {
  phoneNumber: string;
  name?: string;
  telegramId?: string | null;
  lastLoginAt: number | null;
  lastFieldActivityAt: string | null;
  lastSeenAt: string | null;
}

export const fetchUserActivityReport = async (): Promise<UserActivityRow[]> =>
  (await apiClient.get('/api/reports/user-activity')).data.users ?? [];
